<template>
  <div class="user">
    <div class="top" v-if="$store.getters.token">
      <div class="container">
        <div class="top_con">
          <div class="top_l">
            <div class="top_l_l">
              <img :src="info.head_pic" />
            </div>
            <div class="top_l_r">
              <h4>{{ info.user_name }}</h4>
              <p>
                <span>{{ info.sex_name }} | </span>
                <span>{{ info.age }} | </span>
                <span>{{ info.email }}</span>
              </p>
            </div>
          </div>
          <div class="top_r">
            <ul class="r_ul">
              <li
                v-for="(item, i) in buttons"
                :key="i"
                @click="itemClick(i)"
                :class="{ active: item.id == ind }"
              >
                <el-button type="primary" plain>{{ item.text }}</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "user",
  props: {},
  data() {
    return {
      buttons: [
        { text: "已投岗位", id: 0 },
        { text: "基本信息", id: 1 },
        { text: "电子简历", id: 2 },
      ],
      errorHandler: true,
      ind: 0,
      info: {},
    };
  },
  computed: {},
  created() {
    if (this.$store.getters.token) {
      //this.info = this.$store.getters.userInfo.user;
      this.getInfo();
    }
    console.log(window.location.pathname);
    if (window.location.pathname == "/user/already") {
      window.sessionStorage.setItem("ind", 0);
    }
    if (window.sessionStorage.getItem("ind") == null) {
      this.ind = 0;
    } else {
      this.ind = window.sessionStorage.getItem("ind");
    }

    console.log(this.ind);
  },
  mounted() {},
  watch: {
    cli() {
      if (this.i === 0) {
        this.$router.push("/user/already");
      }
    },
  },
  methods: {
    // 获取用户信息
    getInfo() {
      this.info = { ...this.$store.getters.user };
      // console.log(this.info, "11111111111");
    },
    itemClick(i) {
      this.ind = i;
      if (i === 0) {
        this.$router.push("/user/already");
        window.sessionStorage.setItem("ind", 0);
      }
      if (i === 1) {
        this.$router.push("/user/info");
        window.sessionStorage.setItem("ind", 1);
      }
      if (i === 2) {
        this.$router.push("/user/resume");
        window.sessionStorage.setItem("ind", 2);
      }
    },
  },

  components: {
    Footer,
  },
};
</script>

<style lang="less" scoped>
.user {
  margin-top: 0.8rem;
  .top {
    width: 100%;
    height: 1.5rem;
    background-color: #ff7f00;
    .top_con {
      display: flex;
      justify-content: space-between;
    }
    .top_l {
      display: flex;
      align-items: center;
      height: 1.5rem;
      padding-left: 0.4rem;
      .top_l_l {
        width: 0.6rem;
        height: 0.6rem;
        background-color: #fff;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top_l_r {
        padding-left: 0.1rem;
        h4 {
          font-size: 0.18rem;
          color: #fff;
        }
        p {
          font-size: 0.12rem;
          color: #eee;
          line-height: 0.3rem;
        }
      }
    }
    .top_r {
      display: flex;
      align-items: center;
      .r_ul {
        display: flex;
        li {
          margin-left: 0.3rem;
        }
      }
    }
  }
  .content {
    background-color: #e9e9e9;
  }
}
@media only screen and (max-width: 766px) {
  .user {
    margin-top: 1.4rem;
    .top {
      height: 2.8rem;
      .top_con {
        flex-flow: column;
        .top_l {
          justify-content: center;
          flex-direction: column;
          padding-left: 0;
          padding-top: 0.2rem;
          .top_l_l {
            width: 1rem;
            height: 1rem;
            img {
              border-radius: 50%;
            }
          }
          .top_l_r {
            display: flex;
            flex-direction: column;
            align-items: center;

            h4 {
              font-size: 0.28rem;
            }
            p {
              font-size: 0.24rem;
            }
          }
        }
        .top_r {
          margin-top: 0.4rem;
          justify-content: center;
        }
      }
    }
  }
}
</style>
